import React from "react";
import { map } from "lodash";
import { EventItem } from "../EventItem";
import "./EventGrid.scss";

export function EventGrid(props) {
  const { events, onReload } = props;

  return (
    <div className="event-grid">
      {map(events, (event) => (
        <div key={event.id} className="event-grid__item">
          <EventItem event={event} onReload={onReload} />
        </div>
      ))}
    </div>
  );
}
